import React from 'react';

import { Route, Switch, useRouteMatch } from 'react-router-dom';

import SettingsPage from './SettingsPage';

const SettingsRoutes: React.FC = () => {
    const { path } = useRouteMatch();

    console.log('SettingsRoutes path', path);
    return (
        <>
            <Switch>
                <Route exact path={`${path}`} component={SettingsPage} />
            </Switch>
        </>
    );
};

export default SettingsRoutes;
